export interface itemProps {
  title: string;
  href: string;
  id: string;
}

export interface itemsProps {
  title: string;
  href: string;
  id: string;
  children?: itemProps[];
}

export const itemsLeft: itemsProps[] = [
  {
    title: "Produkter",
    href: "/produkter?category=",
    id: "jhdn423n3-23rdfew3fd-423rf43erf",
    children: [
      {
        title: "Alla Produkter",
        href: "/produkter?category=",
        id: "all-produkter-id-123",
      },

      // (Also commented out in produkter/_components/nav.tsx)
      // {
      //   title: "Presentkort",
      //   href: "/produkter/presentkort",
      //   id: "presentkort-id-123",
      // },
      // {
      //   title: "Vintillbehör",
      //   href: "/produkter?category=vintillbehor",
      //   id: "vintillbehor-id-123",
      // },
      // {
      //   title: "Cocktailmaskiner",
      //   href: "/produkter?category=cocktailmaskiner",
      //   id: "cocktailmaskiner-id-456",
      // },
      // {
      //   title: "Dryckesglas och karaffer",
      //   href: "/produkter?category=dryckesglas-och-karaffer",
      //   id: "dryckesglas-id-789",
      // },
      // {
      //   title: "Vinserveringssystem",
      //   href: "/produkter?category=vinserveringssystem",
      //   id: "vinserveringssystem-id-101",
      // },
      // {
      //   title: "Vinställ",
      //   href: "/produkter?category=vinstall",
      //   id: "vinstall-id-112",
      // },
      // {
      //   title: "Pizzaugnar",
      //   href: "/produkter?category=pizzaugnar",
      //   id: "pizzaugnar-id-131",
      // },
      {
        title: "Enomatic-vinservering",
        href: "/enomatic-vinservering",
        id: "outlet-id-415",
      },
      {
        title: "Datum",
        href: "/datum",
        id: "datum-id-123",
      },
    ],
  },
  {
    title: "Presentkort",
    href: "/produkter/presentkort",
    id: "jhdsaeoitfe-sdagfvdgd-423rf43erf",
    children: [
      {
        title: "Presentkort",
        href: "/produkter/presentkort",
        id: "jhdsaeoitfe-sdagfvdgd-423rf43erf",
      },
      {
        title: "Presentkort och bok",
        href: "/produkter/presentkort-och-bok",
        id: "all-produkter-id-123123123",
      },
    ],
  },
];
export const itemsRight: itemsProps[] = [
  {
    title: "Om oss",
    href: "/om-oss",
    id: "ge5ert5yg5re-e5g5ege5-er5g5ege5rtgf",
    children: [
      {
        title: "Blogg",
        href: "/blogg",
        id: "g56t7io8u9-8uolkijhujf-awet4eg",
      },
      {
        title: "Kontakta oss",
        href: "/kontakta-oss",
        id: "egbstdhb-resghsthgyuj-yjdfjdj",
      },
    ],
  },
  {
    title: "Hitta hit",
    href: "/hitta-hit",
    id: "213ekdmferg-123ed3fehj-i78675y34",
  },
];
